import { lazy, Suspense } from "react";
import CircularLoader from "../../../customs/loader/main";
const Main = lazy(() => import("../../../components/settings/score/scoreType/main"));


const ScoreSetUp = () => {
  return (
        <Suspense fallback={<CircularLoader />}>
          <Main />
        </Suspense>
  );
};

export default ScoreSetUp;




